module.exports = __webpack_public_path__ + "createstatic/media/Next-icon.c6c87c86.svg";